var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showNavBar)?_c('NavBar'):_vm._e(),_c('router-view'),(_vm.showFooter)?_c('Footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }